import { Component, Inject, inject, SecurityContext, OnDestroy, ViewChild, ViewContainerRef, model, input, Optional, EventEmitter, output } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatDialogActions,
  MatDialogTitle,
  MatDialogContent,
  MatDialogModule,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DrawComponent } from '@components/draw/draw.component';
import { TablerIconsModule } from 'angular-tabler-icons';
import * as fabric from 'fabric';
import { FilemanagerApiService } from '@services/api/filemanager/filemanager-api.service';
import { BroadcastChannelService } from '@core/broadcast-channel/broadcast-channel.service';
import { ToastrServices } from '@services/toastr/toastr.service';
import { catchError, of, takeUntil } from 'rxjs';
import { ExplorerEntity } from '@app/core/interfaces/explorer-entity';
import { FilemanagerService } from '@app/core/services/filemanager/filemanager.service';
import { event } from 'jquery';
import { ExplorerService } from 'filemanager-explorer';
import { CdkDrag, CdkDragEnd, CdkDragHandle, CdkDragMove, CdkDragStart } from '@angular/cdk/drag-drop';
import { ResizableDirective } from '@app/core/directives/resizable.directive';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-modals-send-file',
  imports: [MatDialogActions, MatDialogTitle, MatDialogContent, MatButtonModule, DrawComponent, TablerIconsModule,
    CdkDrag,
    CdkDragHandle,
    ResizableDirective,
    TranslateModule
  ],
  standalone: true,
  templateUrl: './modals-send-file.component.html',
  styleUrl: './modals-send-file.component.scss'
})
export class ModalsSendFileComponent implements OnDestroy {
  @ViewChild(DrawComponent, { static: false }) drawComponent!: DrawComponent;

  private sanitizer: DomSanitizer = inject(DomSanitizer);
  private filemanager_api_service: FilemanagerApiService = inject(FilemanagerApiService);
  private filemanager_service: FilemanagerService = inject(FilemanagerService);
  private broadcast_service: BroadcastChannelService = inject(BroadcastChannelService);
  private toastr_service: ToastrServices = inject(ToastrServices);
  private translate: TranslateService = inject(TranslateService);
  // private dialogRef: MatDialogRef<ModalsSendFileComponent> = inject(MatDialogRef);
  public dataModule: any;
  directData = input<any>();
  public modal = model<boolean>(false);
  public draggable = model<boolean>(false);
  public resizable = model<boolean>(false);
  public contentType: string = '';
  public fileData: SafeResourceUrl = '';
  private canvas!: fabric.Canvas;
  isEditMode: boolean = false;
  originalFile!: ExplorerEntity
  showClose = model<boolean>(false);
  onCloseComponent = output<{close: boolean}>();

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any, 
    @Optional() private dialog: MatDialog,
    private _explorerService: ExplorerService,
    @Optional() private dialogRef: MatDialogRef<ModalsSendFileComponent>
) {
    
    this.dataModule = data;
  }

  ngOnInit() {

    if (this.directData()) {
      this.dataModule = this.directData();
    }
    const blob = this.dataModule.data;
    this.isEditMode = this.dataModule.edit ?? false;
    this.originalFile = this.dataModule.originalFile;
    
    console.log(this.data);
    if(this.dataModule.showClose){
      this.showClose.set(this.dataModule.showClose);
    }
    if(this.dataModule.draggable){
      this.draggable.set(this.dataModule.draggable);
    }
    if(this.dataModule.resizable){
      this.resizable.set(this.dataModule.resizable);
    }
    if(this.dataModule.modal){
      this.modal.set(this.dataModule.modal);
    }
    this.contentType = blob.type;
    const blobUrl = URL.createObjectURL(blob);
    this.fileData = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
  }

  get fileDataUrl(): string {
    return this.fileData as string;
  }

  getSafeUrlAsString(): string {
    return this.sanitizer.sanitize(SecurityContext.RESOURCE_URL, this.fileData) || '';
  }

  close(): void {
    if(this.dialogRef){
      this.dialogRef.close();
      this.dialogRef.afterClosed().subscribe(() => {
        this.destroyComponent();
      });
    }
  }
  closeDirect(): void {
    
    this.onCloseComponent.emit({close:true});
    this.close();
  }

  canvasReady(event: any): void {
    this.canvas = event;
  }

  saveCanvas(event: any): void {
    if(!event) {
      return
    }
    if(this.isEditMode){
      this.saveFile();
    } else {
      this.sendFile();
    }
  }

  sendFile(): void {
    const base64 = this.canvas.toDataURL({
      format: 'jpeg',
      quality: 1,
      multiplier: 4
    });
    this.filemanager_api_service.saveFileTmpPromise(base64).then((result) => {
      let data = result.data;
      const uuid_file = data['image_uuid'];
      if (!this.isEditMode) {
        this.broadcast_service.connect();
        let body_message = {
          event: 'sendDocuments',
          data: {
            urls: [uuid_file],
            type: 'pdf'
          }
        }
        this.broadcast_service.sendMessage(body_message);
        this.broadcast_service.close();
        this.toastr_service.showSuccess(this.translate.instant('filemanager.toast.image_sent'), this.translate.instant('alert.success'));
      } else {
        this.toastr_service.showSuccess(this.translate.instant('filemanager.toast.image_saved'), this.translate.instant('alert.success'));
      }

    }).catch(err => {
      this.toastr_service.showError(this.translate.instant('filemanager.toast.image_error'), this.translate.instant('alert.error'));
    });
  }

  /**
   * TODO: è necessario chiamare il metodo per fare l'upload dell'immagine
   */
  saveFile(): void {
    const base64 = this.canvas.toDataURL({
      format: 'jpeg',
      quality: 1,
      multiplier: 4
    });

    if (!this.originalFile) {
      this.filemanager_api_service.saveFileTmpPromise(base64).then((result) => {
        let data = result.data;
        const uuid_file = data['image_uuid'];
        if (!this.isEditMode) {
          this.broadcast_service.connect();
          let body_message = {
            event: 'sendDocuments',
            data: {
              urls: [uuid_file],
              type: 'pdf'
            }
          }
          this.broadcast_service.sendMessage(body_message);
          this.broadcast_service.close();
          this.toastr_service.showSuccess(this.translate.instant('filemanager.toast.image_sent'), this.translate.instant('alert.success'));
        } else {
          this.toastr_service.showSuccess(this.translate.instant('filemanager.toast.image_saved'), this.translate.instant('alert.success'));
          this._explorerService.openNode();
        }

      }).catch(err => {
        this.toastr_service.showError(this.translate.instant('filemanager.toast.image_error'), this.translate.instant('alert.error'));
      });
    } else {
      const body: ExplorerEntity = {
        ...this.originalFile,
        name: this.originalFile.name + '_edit',
        field_name: this.originalFile.field_name,
        type: 'file',
        parent: this.originalFile.parent,
        file_base64: base64
      };

      {
        const fileNameSplit = this.originalFile.name.split('.');
        const fileName = fileNameSplit[0];
        const fileExtension = fileNameSplit[1];
        body.name = fileName + '_edit' + (fileExtension ? '.' + fileExtension : '');
      }

      {
        if(this.originalFile.field_name){
          const fileNameSplit = this.originalFile.field_name.split('.');
          const fileName = fileNameSplit[0];
          const fileExtension = fileNameSplit[1];
          body.field_name = fileName + '_edit' + (fileExtension ? '.' + fileExtension : '');
        }
        
      }
      

      this.filemanager_api_service.uploadFile(body).pipe(
        catchError((error) => {
          this.toastr_service.showError(this.translate.instant('filemanager.toast.image_error'), this.translate.instant('alert.error'));
          return of(null);
        })
      ).subscribe((response) => {
        this.toastr_service.showSuccess(this.translate.instant('filemanager.toast.image_saved'), this.translate.instant('alert.success'));
        // TODO: generare evento per effettuare il reload del file manager nella cartella attuale
        this._explorerService.openNode();
      })
    }




  }

  stopCropping(base64: string) {
    this.filemanager_api_service.saveFileTmpPromise(base64).then((result) => {
      let data = result.data;
      const name_file = data['name'];
      const uuid_file = data['image_uuid'];

      return this.filemanager_api_service.getFileBytesToPromise(uuid_file).then((response) => {
        return {
          name_file: name_file,
          uuid_file: uuid_file,
          response: response
        };
      });
    }).then(({ name_file, uuid_file, response }) => {
      let data_response = {
        data: response,
        name: name_file,
        uuid: uuid_file,
      };
      this.updateData(data_response);

      //this.reopenModalWithData(data_response);

    }).catch(err => {
      console.error("Errore:", err);
    });
  }

  private resetDrawComponent(): void {
    if (this.drawComponent) {
      this.drawComponent.reset();
    }
  }

  updateData(data: any): void {
    this.resetDrawComponent();
    this.dataModule = data;
    const blob = this.dataModule.data;
    this.contentType = blob.type;
    const blobUrl = URL.createObjectURL(blob);
    this.fileData = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
  }

  reopenModalWithData(newData: any) {
    this.close(); // Chiudi la modale corrente
    setTimeout(() => {
      this.dialog.open(ModalsSendFileComponent, {
        data: newData,
        width: '950px',
        minHeight: '60vh',
        maxHeight: '90vh',
        maxWidth: '90vw',
      });
    }, 200);
  }

  ngOnDestroy() {
    this.destroyComponent();
  }

  private destroyComponent() {
    if (this.drawComponent) {
      // this.drawComponent.ngOnDestroy();
      this.drawComponent = null as any;
    }
    if (this.broadcast_service) {
      this.broadcast_service.close();
    }
    if (this.canvas) {
      this.canvas.dispose();
      this.canvas = null as any;
    }
    if (this.fileData) {
      URL.revokeObjectURL(this.getSafeUrlAsString());
      this.fileData = '';
    }
    this.dataModule = null;
    this.contentType = null as any;
    this.sanitizer = null as any;
    this.filemanager_api_service = null as any;
    this.broadcast_service = null as any;
    this.toastr_service = null as any;
    this.dialogRef = null as any;
  }

}
